import './animations.js';

(function () {
	const UNDERLINE_PATH = 'M1.37256 32.6716C131.402 16.3176 358.701 -6.57786 227.658 32.6716C96.6152 71.921 286.2 56.9546 397.373 44.5653';
	const SVG_NS = 'http://www.w3.org/2000/svg';
	const DRAW_DURATION = 1400;
	const DRAW_EASING = 'cubic-bezier(0.4, 0, 0.2, 1)';

	function playUnderlineDraw(span, path, prefersReducedMotion) {
		const length = path.getTotalLength();

		path.style.strokeDasharray = String(length);
		path.style.strokeDashoffset = String(length);
		path.style.opacity = '1';
		span.classList.add('is-underline-visible');

		if (prefersReducedMotion) {
			path.style.strokeDashoffset = '0';
			span.classList.add('is-underline-drawn');
			return;
		}

		const animation = path.animate(
			[
				{ strokeDashoffset: length },
				{ strokeDashoffset: 0 },
			],
			{
				duration: DRAW_DURATION,
				fill: 'forwards',
				easing: DRAW_EASING,
			}
		);

		animation.onfinish = function () {
			path.style.strokeDashoffset = '0';
			span.classList.add('is-underline-drawn');
		};
	}

	function initHeadingUnderlines() {
		const spans = document.querySelectorAll('h1 span:not(:has(span))');

		if (!spans.length) {
			return;
		}

		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		spans.forEach(function (span) {
			if (span.querySelector('.heading-underline')) {
				return;
			}

			const svg = document.createElementNS(SVG_NS, 'svg');
			svg.setAttribute('class', 'heading-underline');
			svg.setAttribute('viewBox', '0 0 399 69');
			svg.setAttribute('fill', 'none');
			svg.setAttribute('aria-hidden', 'true');
			svg.setAttribute('preserveAspectRatio', 'xMinYMax meet');

			const path = document.createElementNS(SVG_NS, 'path');
			path.setAttribute('d', UNDERLINE_PATH);

			svg.appendChild(path);
			span.insertBefore(svg, span.firstChild);

			const length = path.getTotalLength();
			path.style.strokeDasharray = String(length);
			path.style.strokeDashoffset = String(length);
			path.style.opacity = '0';

			if (prefersReducedMotion || !('IntersectionObserver' in window)) {
				playUnderlineDraw(span, path, prefersReducedMotion);
				return;
			}

			const revealHost = span.closest('[data-reveal-el]') || span.closest('h1');
			if (revealHost && revealHost.closest('[data-reveal]') && !revealHost.classList.contains('is-revealed')) {
				revealHost.addEventListener('reveal:complete', function onRevealComplete() {
					revealHost.removeEventListener('reveal:complete', onRevealComplete);
					playUnderlineDraw(span, path, false);
				});
				return;
			}

			const observer = new IntersectionObserver(
				function (entries, obs) {
					entries.forEach(function (entry) {
						if (!entry.isIntersecting) {
							return;
						}

						const targetPath = entry.target.querySelector('.heading-underline path');

						if (targetPath) {
							playUnderlineDraw(entry.target, targetPath, false);
						}

						obs.unobserve(entry.target);
					});
				},
				{ threshold: 0.25 }
			);

			observer.observe(span);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initHeadingUnderlines);
	} else {
		initHeadingUnderlines();
	}
})();

jQuery(document).ready(function($) {

    $(window).on('scroll', function(){
        if($(window).scrollTop() > 50) {
            $('.site-header').addClass('scrolled');
        } else {
            $('.site-header').removeClass('scrolled');
        }
    });

    function setHeaderHeight() {
        const headerHeight = $('.site-header').outerHeight() || 112;
        const adminBar = document.getElementById('wpadminbar');
        const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
        document.documentElement.style.setProperty('--site-header-height', headerHeight + 'px');
        document.documentElement.style.setProperty('--site-header-offset', (headerHeight + adminBarHeight) + 'px');
    }

    setHeaderHeight();
    $(window).on('resize', setHeaderHeight);

    function closeMobileNav() {
        $('.menutoggle').removeClass('open');
        $('.site-header__nav').removeClass('open');
        $('body').removeClass('nav-open');
    }

    $('.menutoggle').on('click', function(){
        $(this).toggleClass('open');
        $('.site-header__nav').toggleClass('open');
        $('body').toggleClass('nav-open');
    });

    $('.site-header__overlay').on('click', function(){
        closeMobileNav();
    });

    $('.menu-item-has-children > a').on('click', function(e){
        if($(window).width() < 1200) {
            e.preventDefault();
            $(this).parent().toggleClass('open');
            $(this).parent().find('.sub-menu').slideToggle();
        }
    });

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        }
        else var expires = "";               
    
        document.cookie = name + "=" + value + expires + "; path=/";
    }
    
    function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
    
    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

	if($('.testimonials__item').length > 0) {
		const testimonialsSwiper = new Swiper('.testimonials__wrapper', {
			slidesPerView: 1,
			spaceBetween: 30,
			loop: true,
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
			},
		});

		$('.testimonials__controls-next').on('click', function(){
			testimonialsSwiper.slideNext();
		});

		$('.testimonials__controls-prev').on('click', function(){
			testimonialsSwiper.slidePrev();
		});
	}

	$('.faqs__faq-question').on('click', function(){
		$(this).toggleClass('active');
		$(this).parent().find('.faqs__faq-answer').slideToggle();
	});

	$('.contact-embed__tab').on('click', function(){
		console.log('click');
		$('.contact-embed__tab').removeClass('active');
		$(this).addClass('active');
		let tab = $(this).data('tab');
		console.log(tab);
		$('.contact-embed__tab-content').removeClass('active');
		$('.contact-embed__tab-content[data-tab="' + tab + '"]').addClass('active');
	});

	$('.js-scroll-to-section').on('click', function(e){
		const targetId = $(this).data('scroll-target');
		const $target = $('#' + targetId);

		if (!$target.length) {
			return;
		}

		e.preventDefault();

		const headerOffset = $('.site-header').outerHeight() || 0;
		const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		const scrollTop = $target.offset().top - headerOffset - 20;

		$('html, body').stop().animate(
			{ scrollTop: scrollTop },
			prefersReducedMotion ? 0 : 600
		);
	});

	function updateHeroSwitchCards($hero) {
		const $activeOption = $hero.find('.hero__switch-option.is-active');
		const hasActiveOption = $activeOption.length > 0;

		$hero.find('.hero__switch-option').each(function () {
			const $option = $(this);
			if (hasActiveOption && !$option.hasClass('is-active')) {
				$option.addClass('is-grayscale');
			} else {
				$option.removeClass('is-grayscale');
			}
		});
	}

	$('.hero--has-switch').each(function () {
		updateHeroSwitchCards($(this));
	});

	$('.hero--has-switch .hero__switch-option').on('click', function(){
		const $hero = $(this).closest('.hero--has-switch');
		const panelId = $(this).data('hero-panel');

		$hero.find('.hero__switch-option').removeClass('is-active').attr('aria-pressed', 'false');
		$(this).addClass('is-active').attr('aria-pressed', 'true');

		$hero.find('.hero__panel').removeClass('is-active').attr('hidden', true);
		const $panel = $hero.find('.hero__panel[data-hero-panel="' + panelId + '"]');
		$panel.addClass('is-active').removeAttr('hidden');
		$panel.find('[data-reveal-el]').each(function () {
			this.classList.add('is-revealed');
			this.style.opacity = '1';
			this.style.transform = 'none';
		});

		updateHeroSwitchCards($hero);
	});

	$(document).on('keydown', '.js-open-popup[role="button"]', function(e) {
		if (e.key === 'Enter' || e.key === ' ') {
			e.preventDefault();
			const popupId = $(this).data('popup-id');

			if (popupId) {
				openPopup(popupId);
			}
		}
	});

	function setModalHidden($modal) {
		$modal.removeClass('is-open').attr('aria-hidden', 'true').prop('inert', true);
	}

	function closePopups() {
		$('.bc-modal.is-open').each(function () {
			setModalHidden($(this));
		});
		$('body').removeClass('modal-active');
	}

	function openPopup(popupId) {
		const $modal = $('.bc-modal[data-popup-id="' + popupId + '"]');

		if (!$modal.length) {
			return;
		}

		closePopups();
		$modal.addClass('is-open').attr('aria-hidden', 'false').prop('inert', false);
		$('body').addClass('modal-active');
		$modal.find('.bc-modal__close').trigger('focus');
	}

	$('.bc-modal').not('.is-open').each(function () {
		setModalHidden($(this));
	});

	$(document).on('click', '.js-open-popup', function(e) {
		e.preventDefault();
		const popupId = $(this).data('popup-id');

		if (popupId) {
			openPopup(popupId);
		}
	});

	$(document).on('click', '.js-popup-close', function() {
		closePopups();
	});

	$(document).on('keydown', function(e) {
		if (e.key === 'Escape') {
			closePopups();
		}
	});

	function initBrandsMarquee() {
		const viewports = document.querySelectorAll('.brandscarousel__viewport');
		if (!viewports.length) {
			return;
		}

		function layout() {
			viewports.forEach(function (viewport) {
				const track = viewport.querySelector('.brandscarousel__track');
				if (!track) {
					return;
				}

				let visible = 4;
				if (window.matchMedia('(min-width: 1024px)').matches) {
					visible = 8;
				} else if (window.matchMedia('(min-width: 767px)').matches) {
					visible = 6;
				}

				viewport.style.setProperty('--brand-slot', (viewport.clientWidth / visible) + 'px');

				const distance = track.scrollWidth / 2;
				if (distance > 0) {
					track.style.animationDuration = Math.max(30, distance / 40) + 's';
				}
			});
		}

		layout();
		window.addEventListener('resize', layout);
	}

	initBrandsMarquee();

});